import axios from 'axios';

const fetch = axios.create({
  baseURL: 'http://api-family-style.mombaby.kroutony.me/api/',
});

fetch.interceptors.request.use(
  function (config) {
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
);

fetch.interceptors.response.use(
  function (response) {

    return response
  },
  function (error) {
    if (error.response) {
      switch (error.response.status) {
        case 400:
          switch (error.response.data.status) {
            case 400001:
              alert('今天已投過票');
              break
            case 400002:
              alert('投票截止囉！感謝您的參與，抽獎結果將於9/11 18:00前公布於媽媽寶寶官網-得獎公告');
              break
            default:
              alert('請填寫所有欄位');
          }
          break
        case 404:
          console.log('你要找的頁面不存在');
          break
        case 500:
          console.log('程式發生問題')
          break
        default:
          console.log(error.message)
      }
    }
    if (!window.navigator.onLine) {
      alert('網路出了點問題，請重新連線後重整網頁');
      return false;
    }
    return Promise.reject(error);
  }
)

export default fetch;
